/* eslint-disable @typescript-eslint/no-explicit-any */
import { Progress } from "antd";
import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import { ResetLoading, getLoadStatus, getTotalRequest } from "../../../redux/features/loader";
import "./style.scss";
interface Props {
  status?: "normal" | "exception" | "active" | "success";
  type?: "line" | "circle" | "dashboard";
  showInfo?: boolean;
}

const AppProgressBar: React.FC<Props> = ({ status, type, showInfo = false }) => {
  const dispatch = useAppDispatch();
  const loading = useAppSelector(getLoadStatus);
  const totalRequest = useAppSelector(getTotalRequest);

  const getPrecentage = (loadingStatus: number, totalLoader: number): number => {
    const percentage = (loadingStatus / totalLoader) * 100;
    if (percentage < 90) {
      return 90;
    } else {
      return percentage;
    }
  };
  useEffect(() => {
    if (loading == totalRequest) {
      dispatch(ResetLoading());
    }
  }, [loading, totalRequest]);
  return (
    <div className={"custom-api-progress"}>
      {loading < totalRequest && (
        <Progress
          percent={getPrecentage(loading, totalRequest)}
          status={status}
          type={type}
          showInfo={showInfo}
          strokeWidth={3}
        />
      )}
    </div>
  );
};

export default AppProgressBar;
